import { parseColor } from '@ark-ui/react/color-picker'

export function getMentionBackgroundColor(mentionColor: string) {
  const parsedColor = parseColor(mentionColor)

  const supportedChannels = parsedColor.getChannels()

  if (!supportedChannels.includes('lightness')) {
    return parsedColor.toString('css')
  }

  let newColor = parsedColor.clone()
  const lightness = Math.ceil(
    parsedColor.getChannelValuePercent('lightness') * 100,
  )

  if (lightness > 70) {
    newColor = newColor
      .decrementChannel('lightness', 20)
      .decrementChannel('alpha', 0.4)
  } else if (lightness > 40) {
    newColor = newColor.decrementChannel('lightness', 20)
  } else if (lightness > 20) {
    newColor = newColor.decrementChannel('lightness', 8)
  } else if (lightness > 10) {
    newColor = newColor.decrementChannel('lightness', 3)
  }

  return newColor.toString('css')
}

export function getMentionColorLightness(
  mentionColor?: string,
): 'light' | 'dark' {
  if (!mentionColor) return 'dark'

  const parsedColor = parseColor(mentionColor)

  if (!parsedColor) return 'dark'

  if (parsedColor.getChannels().includes('lightness')) {
    return parsedColor.getChannelValue('lightness') >= 50 ? 'light' : 'dark'
  } else if (parsedColor.getFormat() === 'rgba') {
    const r = parsedColor.getChannelValue('red')
    const g = parsedColor.getChannelValue('green')
    const b = parsedColor.getChannelValue('blue')

    const yiq = (r * 299 + g * 587 + b * 114) / 1000

    return yiq >= 128 ? 'light' : 'dark'
  }

  return 'dark'
}

export function getMentionColors(mentionColor: string) {
  const parsedColor = parseColor(mentionColor)

  const backgroundColor = getMentionBackgroundColor(mentionColor)

  return {
    color:
      getMentionColorLightness(backgroundColor) === 'light' ? '#000' : '#fff',
    backgroundColor,
    iconBackgroundColor: parsedColor.toString('css'),
  }
}
